/* import __COLOCATED_TEMPLATE__ from './action-cell.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';

interface CellActionCellSignature {
  Args: {
    cell: any;
    column: any;
    row: any;
    scrollToRow: (rowModelId: string) => void;
  };
}

const CellActionCellComponent = templateOnlyComponent<CellActionCellSignature>();

export default CellActionCellComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Cell::ActionCell': typeof CellActionCellComponent;
    'cell/action-cell': typeof CellActionCellComponent;
  }
}
